import { Location } from 'history';
import { REACT_APP_GLOBAL_API_BASE_URL_V2 } from 'runtimeEnvVars';

import { buildApplicantsQueryParams } from 'containers/ApplicantTableV2/queryParams';
import { resolveProfileViewSource } from 'utils/applicantProfileView';
import { apiGet } from 'utils/axios';

export interface LoadQueueInput {
  location: Location;
  currentId: string;
  searchQuery?: string;
  stageId?: string;
  funnelId?: string;
}

export function isUniversalSearchOpen(location: Pick<Location, 'search'>) {
  return (
    new URLSearchParams(location.search).get('applicantOpenSource') ===
    'universal_search'
  );
}

export async function loadQueue({
  location,
  currentId,
  searchQuery,
  stageId,
  funnelId,
}: LoadQueueInput): Promise<{ ids: string[]; truncated: boolean } | null> {
  const source = resolveProfileViewSource({
    isPagination: false,
    pathname: location.pathname,
    search: location.search,
    accountSlug: location.pathname.split('/')[1],
  });
  if (
    isUniversalSearchOpen(location) ||
    (source !== 'pipeline_board' &&
      source !== 'applicant_list' &&
      source !== 'applicant_search')
  ) {
    return null;
  }
  try {
    const { data } = await apiGet(
      `${REACT_APP_GLOBAL_API_BASE_URL_V2}/applicants`,
      {
        ...buildApplicantsQueryParams(location, {
          query: searchQuery,
          stageId,
          funnelId,
        }),
        page: undefined,
        per_page: undefined,
        ids_only: true,
      },
    );
    if (
      !Array.isArray(data?.ids) ||
      !data.ids.every((id: unknown) => typeof id === 'string') ||
      typeof data.truncated !== 'boolean' ||
      !data.ids.includes(currentId)
    ) {
      return null;
    }
    return { ids: data.ids, truncated: data.truncated };
  } catch {
    return null;
  }
}
